import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/theme.css';
import './assets/css/fonts.css';
import './assets/css/reset.css';
import './assets/css/global.css';
import reportWebVitals from './reportWebVitals';

// You shouldn't modify this JS File. If you want to add wrapper, search for App.js instead

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
